module.exports = __webpack_public_path__ + "static/media/ic_add_new_group.ecb14abb.svg";